// OBS: this file is written by the buildscript!
const FrontendBuildCommit = "1e41a98";
export default FrontendBuildCommit;